/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NonTaxableInstitutionDetailsViewModel } from './NonTaxableInstitutionDetailsViewModel';
import {
    NonTaxableInstitutionDetailsViewModelFromJSON,
    NonTaxableInstitutionDetailsViewModelFromJSONTyped,
    NonTaxableInstitutionDetailsViewModelToJSON,
} from './NonTaxableInstitutionDetailsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfNonTaxableInstitutionDetailsViewModel
 */
export interface ResultOfNonTaxableInstitutionDetailsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfNonTaxableInstitutionDetailsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfNonTaxableInstitutionDetailsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfNonTaxableInstitutionDetailsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfNonTaxableInstitutionDetailsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfNonTaxableInstitutionDetailsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfNonTaxableInstitutionDetailsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfNonTaxableInstitutionDetailsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {NonTaxableInstitutionDetailsViewModel}
     * @memberof ResultOfNonTaxableInstitutionDetailsViewModel
     */
    data?: NonTaxableInstitutionDetailsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfNonTaxableInstitutionDetailsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfNonTaxableInstitutionDetailsViewModel interface.
 */
export function instanceOfResultOfNonTaxableInstitutionDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfNonTaxableInstitutionDetailsViewModelFromJSON(json: any): ResultOfNonTaxableInstitutionDetailsViewModel {
    return ResultOfNonTaxableInstitutionDetailsViewModelFromJSONTyped(json, false);
}

export function ResultOfNonTaxableInstitutionDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfNonTaxableInstitutionDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : NonTaxableInstitutionDetailsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfNonTaxableInstitutionDetailsViewModelToJSON(value?: ResultOfNonTaxableInstitutionDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': NonTaxableInstitutionDetailsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

